export default __webpack_public_path__ + "static/media/vp_golf.ec9c7da4.svg";